import { DEBT_TYPE_API_TO_LABEL } from './debts.constants';

export const DEBENTURE_DEBT_TYPE = 'DEBENTURE';

const DEBENTURE_VALUES: readonly string[] = [
  DEBENTURE_DEBT_TYPE,
  DEBT_TYPE_API_TO_LABEL[DEBENTURE_DEBT_TYPE],
];

export const isDebentureType = (debtType: string | null | undefined): boolean =>
  !!debtType && DEBENTURE_VALUES.includes(debtType);
